import request from '../request'

export const getLearningContinuum = (curriculumId, filter) =>
  request.post(`/assessment/${curriculumId}/learning-continuum/list`, { filter }).then((res) => res)

export const importLearningContinuum = (curriculumId, file) =>
  request.post(`/assessment/${curriculumId}/learning-continuum/import`, file).then((res) => res)

export const getLearningContinuumSkipLimit = (curriculumId, skip = 0, limit = 5, filter) =>
  request
    .post(`/assessment/${curriculumId}/learning-continuum/list/skip/${skip}/limit/${limit}`, { filter })
    .then((res) => res)

export const getLearningContinuaById = (curriculumId, id) =>
  request.get(`/assessment/${curriculumId}/learning-continuum/${id}`).then((res) => res)

export const createLearningContinua = (curriculumId, data) =>
  request.post(`/assessment/${curriculumId}/learning-continuum`, data).then((res) => res)

export const cloneLearningContinua = (curriculumId, id) =>
  request.post(`/assessment/${curriculumId}/learning-continuum/${id}/clone`).then((res) => res)

export const updateLearningContinua = (curriculumId, id, type, data) =>
  request.put(`/assessment/${curriculumId}/learning-continuum/${id}/${type}`, data).then((res) => res)

export const archiveLearningContinua = (curriculumId, id) =>
  request.delete(`/assessment/${curriculumId}/learning-continuum/${id}/archive`).then((res) => res)

export const deleteLearningContinua = (curriculumId, id) =>
  request.delete(`/assessment/${curriculumId}/learning-continuum/${id}`).then((res) => res)

export const batchDeleteLearningContinua = (curriculumId, lcIds = []) =>
  request.post(`/assessment/${curriculumId}/learning-continuum/batch/delete`, { lcIds }).then((res) => res)
